import type { FC, HTMLAttributes, PropsWithChildren } from 'react';

import { THEME_DATA_IDENTIFIER } from '@eneco/sparky/providers';
import { themeClassNames as stitchesThemeClassNames } from '@eneco/sparky/stitches';
import { themeClassNames as vanillaExtractThemeClassNames } from '@eneco/sparky/theme';
import { getClassNames } from '@eneco/sparky/util/css';

export const Body: FC<PropsWithChildren<HTMLAttributes<HTMLBodyElement>>> = ({ children, ...props }) => {
  const themeClasses = getClassNames(stitchesThemeClassNames['default'], vanillaExtractThemeClassNames['default']);

  return (
    <body className={themeClasses} {...{ [`data-${THEME_DATA_IDENTIFIER}`]: themeClasses }} {...props}>
      {children}
    </body>
  );
};
